<template>
  <div class="faq">
    <div class="faq-question-s" v-b-toggle.q16>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q16.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q16')}}</b-col>
      </b-row>
      <b-collapse id="q16">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A16.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a16-1')}}</div>
            <br />
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(a)</b></b-col>
              <b-col cols="11" class="bd-orange">{{$t('a16-2')}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="1" class="bd-orange"></b-col>
              <b-col cols="11">
                <span v-html="$t('a16-3')"></span>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(b)</b></b-col>
              <b-col cols="11" class="bd-orange">{{$t('a16-4')}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="1" class="bd-orange"></b-col>
              <b-col cols="11">
                <span v-html="$t('a16-5')"></span>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(c)</b></b-col>
              <b-col cols="11" class="bd-orange">{{$t('a16-6')}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="1" class="bd-orange"></b-col>
              <b-col cols="11">
                <span v-html="$t('a16-7')"></span>
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="1" class="bd-orange"><b>(d)</b></b-col>
              <b-col cols="11" class="bd-orange">{{$t('a16-8')}}</b-col>
            </b-row>
            <b-row>
              <b-col cols="1" class="bd-orange"></b-col>
              <b-col cols="11">
                {{$t('a16-9')}}
              </b-col>
            </b-row>
            <br />
            <b-row>
              <b-col cols="1" class="bd-orange"><b>{{ $t('a16-10') }}</b></b-col>
              <b-col cols="11">{{$t('a16-11')}}</b-col>
            </b-row>
            <br />
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q17>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q17.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q17')}}</b-col>
      </b-row>
      <b-collapse id="q17">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A17.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a17-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q18>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q18.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q18')}}</b-col>
      </b-row>
      <b-collapse id="q18">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A18.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a18-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q19>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q19.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q19')}}</b-col>
      </b-row>
      <b-collapse id="q19">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A19.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a19-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q20>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q20.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q20')}}</b-col>
      </b-row>
      <b-collapse id="q20">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A20.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a20-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q21>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q21.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q21')}}</b-col>
      </b-row>
      <b-collapse id="q21">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A21.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a21-1')}}</div>
            <br/>
            <div>{{$t('a21-2')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q22>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q22.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q22')}}</b-col>
      </b-row>
      <b-collapse id="q22">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A22.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a22-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q23>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q23.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q23')}}</b-col>
      </b-row>
      <b-collapse id="q23">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A23.</b></b-col>
          <b-col cols="11">
            <div>{{$t('a23-1')}}</div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-s" v-b-toggle.q24>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q24.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q24')}}</b-col>
      </b-row>
      <b-collapse id="q24">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A24.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a24-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>

    <div class="faq-question-e" v-b-toggle.q25>
      <b-row>
        <b-col cols="1" class="bd-blue"><b>Q25.</b></b-col>
        <b-col cols="11" class="bd-blue">{{$t('q25')}}</b-col>
      </b-row>
      <b-collapse id="q25">
        <b-row>
          <b-col cols="1" class="bd-orange"><b>A25.</b></b-col>
          <b-col cols="11">
            <div v-html="$t('a25-1')"></div>
          </b-col>
        </b-row>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    }
  }
};
</script>

<i18n src="@/public/locales/modules/faq/components/FaqUser.json" />